import { type BridgeEventType } from "./types"
import { BRIDGE_EVENTS, BRIDGE_PROTOCOL } from "./constants"

export const isAllowedOrigin = (
  origin: string,
  AllowedOrigins: string[]
): boolean => AllowedOrigins.includes(origin)

export const isObject = (v: unknown): v is Record<string, unknown> =>
  typeof v === "object" && v !== null

export const isEnvelope = (
  data: unknown
): data is {
  protocol: string
  version: number
  type: string
  id: string
  ts: number
  payload: unknown
} => {
  if (!isObject(data)) return false
  return (
    data.protocol === BRIDGE_PROTOCOL.CHANNEL &&
    data.version === BRIDGE_PROTOCOL.VERSION &&
    typeof data.type === "string" &&
    typeof data.id === "string" &&
    typeof data.ts === "number" &&
    "payload" in data
  )
}

export const isEventType = (t: string): t is BridgeEventType => {
  const knownEvents: BridgeEventType[] = Object.values(BRIDGE_EVENTS)
  return knownEvents.includes(t as BridgeEventType)
}
